import {
  FETCH_BRAND_AFFINITY_BRANDS_REPORT,
  FETCH_BRAND_AFFINITY_BRANDS_REPORT_ERROR,
  SET_BRAND_AFFINITY_BRANDS_REPORT,
  FETCH_BRAND_AFFINITY_SUMMARYCARD,
  FETCH_BRAND_AFFINITY_SUMMARYCARD_ERROR,
  SET_BRAND_AFFINITY_SUMMARYCARD,
  FETCH_BRAND_AFFINITY_CATEGORIES_REPORT,
  FETCH_BRAND_AFFINITY_CATEGORIES_REPORT_ERROR,
  SET_BRAND_AFFINITY_CATEGORIES_REPORT,
  FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT,
  FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT_ERROR,
  SET_BRAND_AFFINITY_TOP_TOIS_REPORT,
  FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT,
  FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT_ERROR,
  SET_CATEGORY_AFFINITY_TOP_TOIS_REPORT,
  FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS,
  FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS_ERROR,
  SET_BRAND_AFFINITY_ORGANISATION_OPTIONS,
  FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS,
  FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS_ERROR,
  SET_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS,
  SET_BRAND_AFFINITY_TOP_POIS_ORGANISATION_OPTION,
  SET_BRAND_AFFINITY_TOP_POIS_SUBCATEGORIES_OPTION,
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS,
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS_SUCCESS,
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS_FAILURE,
  CLEAR_BRAND_AFFINITY_TOP_POI_OPTIONS,
  SELECT_BRAND_AFFINITY_TIME_PERIOD
} from '../constants';


const initialState = {

  brandReportDataLoaded: false,
  brandReportData: [],
  brandAffinitySummaryDataLoaded: false,
  brandAffinitySummaryData: {},
  categoriesReportDataLoaded: false,
  categoriesReportData: [],
  topPoisCategoryAffinityData: [],
  topPoisCategoryAffinityDataLoaded: true,
  topPoisBrandAffinityData: [],
  topPoisBrandAffinityDataLoaded: true,
  organisationOptionsDataLoaded: false,
  organisationOptionsData: [],
  subcategoriesOptionsDataLoaded: false,
  subcategoriesOptionsData: [],
  brandAffinityTopPoiBrandOption: null,
  brandAffinityTopPoiCategoryOption: null,
  currentTopPoisTab: 'brand_affinity',
  downloadingCSV: false,
  csvType: null,
  selectedPeriod: {
    label: 'Last 90 days',
    value: 90
  },
}


const brandAffinity = (state = initialState, action) => {

  switch (action.type) {
    case SELECT_BRAND_AFFINITY_TIME_PERIOD:
      return {
        ...state,
        selectedPeriod: action.selectedPeriod,
      };
    case SET_BRAND_AFFINITY_TOP_POIS_ORGANISATION_OPTION:

      return {
        ...state,
        currentTopPoisTab: 'brand_affinity',
        brandAffinityTopPoiBrandOption:
          action.option !== null
            ? {
              label: action.option.name,
              value: action.option.id,
            }
            : null
      };
    case SET_BRAND_AFFINITY_TOP_POIS_SUBCATEGORIES_OPTION:
      return {
        ...state,
        currentTopPoisTab: 'category_affinity',
        brandAffinityTopPoiCategoryOption:
          action.option !== null
            ? {
              label: action.option.name,
              value: action.option.id,
            }
            : null
      };
    case CLEAR_BRAND_AFFINITY_TOP_POI_OPTIONS:
      return {
        ...state,
        brandAffinityTopPoiBrandOption: null,
        brandAffinityTopPoiCategoryOption: null
      };
    case FETCH_BRAND_AFFINITY_BRANDS_REPORT:
      return {
        ...state,
        brandReportDataLoaded: false,
      };
    case FETCH_BRAND_AFFINITY_BRANDS_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_BRAND_AFFINITY_BRANDS_REPORT:
      return {
        ...state,
        brandReportDataLoaded: true,
        brandReportData: action.data,
      };
    case FETCH_BRAND_AFFINITY_SUMMARYCARD:
      return {
        ...state,
        brandAffinitySummaryDataLoaded: false,
      };
    case FETCH_BRAND_AFFINITY_SUMMARYCARD_ERROR:
      return {
        ...state,
      };
    case SET_BRAND_AFFINITY_SUMMARYCARD:
      return {
        ...state,
        brandAffinitySummaryDataLoaded: true,
        brandAffinitySummaryData: action.data,
      };
    case FETCH_BRAND_AFFINITY_CATEGORIES_REPORT:
      return {
        ...state,
        categoriesReportDataLoaded: false,
      };
    case FETCH_BRAND_AFFINITY_CATEGORIES_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_BRAND_AFFINITY_CATEGORIES_REPORT:
      return {
        ...state,
        categoriesReportDataLoaded: true,
        categoriesReportData: action.data,
      };
    case FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT:
      return {
        ...state,
        topPoisBrandAffinityDataLoaded: false,
      };
    case FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_BRAND_AFFINITY_TOP_TOIS_REPORT:
      return {
        ...state,
        topPoisBrandAffinityDataLoaded: true,
        topPoisBrandAffinityData: action.data,
      };
    case FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT:
      return {
        ...state,
        topPoisCategoryAffinityDataLoaded: false,
      };
    case FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT_ERROR:
      return {
        ...state,
      };
    case SET_CATEGORY_AFFINITY_TOP_TOIS_REPORT:
      return {
        ...state,
        topPoisCategoryAffinityDataLoaded: true,
        topPoisCategoryAffinityData: action.data,
      };

    case FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS:
      return {
        ...state,
        organisationOptionsDataLoaded: false,
      };
    case FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS_ERROR:
      return {
        ...state,
      };
    case SET_BRAND_AFFINITY_ORGANISATION_OPTIONS:
      return {
        ...state,
        organisationOptionsDataLoaded: true,
        organisationOptionsData: action.data,
      };
    case FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS:
      return {
        ...state,
        subcategoriesOptionsDataLoaded: false,
      };
    case FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS_ERROR:
      return {
        ...state,
      };
    case SET_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS:
      return {
        ...state,
        subcategoriesOptionsDataLoaded: true,
        subcategoriesOptionsData: action.data,
      };
    case DOWNLOAD_BRAND_AFFINITY_INSIGHTS:
      return {
        ...state,
        downloadingCSV: true,
        csvType: action.csvType,
      };
    case DOWNLOAD_BRAND_AFFINITY_INSIGHTS_SUCCESS:
      return {
        ...state,
        downloadingCSV: false,
      };
    case DOWNLOAD_BRAND_AFFINITY_INSIGHTS_FAILURE:
      return {
        ...state,
        downloadingCSV: false,
      };

    default:
      return state;
  }
}

export default brandAffinity;
